var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorrowing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#D0F9EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.666 19.2135L36.786 17.3335L21.3327 32.7868V24.0002H18.666V37.3335H31.9993V34.6668H23.2127L38.666 19.2135Z",
    fill: "#2F9F77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrowing);
export default __webpack_public_path__ + "static/media/borrowing.a6c235a9153d3a5d3c52ae6d4cdd0e11.svg";
export { ForwardRef as ReactComponent };